import { TsrctDemandListItem } from '@/generated/gql/graphql';

export enum NegotiationDemandDataGridField {
  ID = 'id',
  PRIORITY = 'priority',
  SEQUENCE_NUMBER = 'sequenceNumber',
  DESCRIPTION = 'description',
  ORGANIZATION_ID = 'organizationId',
  PRIMARY_COMMODITY_GROUP = 'primaryCommodityGroupId',
  COMMODITY_GROUP_IDS = 'commodityGroupIds',
  TOTAL_VALUE = 'totalValue',
  STATUS = 'status',
  REQUESTED_AT = 'requestedAt',
  EARLY_DELIVERY_AT = 'earlyDeliveryAt',
  LATE_DELIVERY_AT = 'lateDeliveryAt',
  PREFERRED_SUPPLIER_IDS = 'preferredSupplierIds',
  CAPABILITY_IDS = 'capabilityIds',
  REQUESTED_BY = 'requestedBy',
  RESPONSIBLE_IDS = 'responsibleIds',
  LINKS = 'links',
  REFERENCE_ID = 'referenceId',
  PROCESS_STATUS = 'processStatus',
  PROCESS_STEPS = 'processSteps',
  PROCESSING_MODE = 'processingMode',
  CASES_NEGOTIATED_COUNT = 'casesNegotiatedCount',
  CASES_OPEN_COUNT = 'casesOpenCount',
  CASES_TOTAL_COUNT = 'casesTotalCount',
  SOURCE_SYSTEM_ID = 'sourceSystemId',
  CASES_ISSUES_OPEN_COUNT = 'issuesOpenCount',
}

export enum NegotiationDemandDataGridColumnGroup {
  DEMAND = 'demand',
  REQUESTED = 'requested',
  DELIVERY_DATE = 'deliveryDate',
  CASES = 'cases',
  RESPONSIBLE = 'responsible',
  SOURCE = 'source',
}

export type NegotiationDemandDataGridRow = TsrctDemandListItem;
